import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTextDecorationLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Capa_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 160 156",
	width: "100%",
	height: "100%",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M109.19,42c-1.61.99-4.2,1.12-6.96.1-1.76-.65-3.5-1.62-5.19-2.62-5.02-2.97-10.06-5.91-15-9.09-2.83-1.82-5.68-3.82-8.18-6.2-2.72-2.6-3.48-6.3-2.46-8.92,1.04-2.68,3.67-3.93,7.08-2.72,10.64,3.76,20.83,9.19,30.24,16.89,4.8,3.93,5.14,9.6.47,12.57Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M38.82,70.36c.83-1.7,2.94-3.21,5.82-3.82,1.84-.39,3.82-.51,5.78-.58,5.83-.19,11.66-.42,17.54-.4,3.36.01,6.84.17,10.23.84,3.69.73,6.32,3.45,6.87,6.2.56,2.82-.99,5.29-4.5,6.1-10.99,2.54-22.51,3.44-34.58,2.01-6.15-.73-9.5-5.33-7.16-10.35Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M65.17,138.22c-.31-1.87.53-4.32,2.53-6.49,1.27-1.38,2.82-2.63,4.38-3.82,4.64-3.54,9.26-7.1,14.06-10.49,2.75-1.94,5.67-3.83,8.82-5.25,3.43-1.54,7.15-.85,9.19,1.07,2.1,1.97,2.26,4.88-.13,7.58-7.48,8.45-16.34,15.86-27.01,21.68-5.44,2.97-10.83,1.16-11.83-4.28Z"
		})
	]
});
export default SvgTextDecorationLeft;
